import { createNativeRequest, platform } from '@mx/core';
import { AxiosRequestConfig } from 'axios';

import { request } from '../request';
import {
  IDeleteFmDraftReq,
  IDeleteFMDraftReq,
  IDeleteFmDraftResp,
  IDeleteFMDraftResp,
  IGenerateFMDraftReq,
  IGenerateFMDraftResp,
  IGetFMCreateConfigReq,
  IGetFMCreateConfigResp,
  IGetFMDraftListReq,
  IGetFMDraftListResp,
  IGetFmDraftReq,
  IGetFmDraftResp,
  IGetNpcListForFmReq,
  IGetNpcListForFmResp,
  IGetNpcProfileReq,
  IGetNpcProfileResp,
  IModerationTextReq,
  IModerationTextResp,
  IPageQueryBgmListByTagIdReq,
  IPageQueryBgmListByTagIdResp,
  IPreviewToneReq,
  IPreviewToneResp,
  IQueryBgmCategoryListReq,
  IQueryBgmCategoryListResp,
  ISubmitFMDraftReq,
  ISubmitFMDraftResp,
  IUpdateFMDraftReq,
  IUpdateFMDraftResp,
} from '../types/fm';

export const postGetFMDraftList = async (
  params: IGetFMDraftListReq,
  config?: AxiosRequestConfig
) => {
  const url = '/weaver/api/v1/ugc/fm/get_fm_draft_list';

  if (platform.isNativePlatform) {
    return createNativeRequest<IGetFMDraftListResp>({
      method: 'POST',
      url,
      data: params,
    });
  }

  return request.post<IGetFMDraftListResp>(url, params, config);
};

export const postGetNpcListForFm = async (
  data: IGetNpcListForFmReq,
  config?: AxiosRequestConfig
) => {
  const url = '/weaver/api/v1/ugc/fm/get_npc_list_for_fm_create';

  if (platform.isNativePlatform) {
    return createNativeRequest<IGetNpcListForFmResp>({
      method: 'POST',
      url,
      data,
    });
  }

  return request.post<IGetNpcListForFmResp>(url, data, config);
};

export const postGetFMCreateConfig = async (
  params: IGetFMCreateConfigReq,
  config?: AxiosRequestConfig
) => {
  const url = '/weaver/api/v1/ugc/fm/get_fm_create_config';

  if (platform.isNativePlatform) {
    return createNativeRequest<IGetFMCreateConfigResp>({
      method: 'POST',
      url,
      data: params,
    });
  }

  return request.post<IGetFMCreateConfigResp>(url, params, config);
};

export const postSubmitFMDraft = async (params: ISubmitFMDraftReq, config?: AxiosRequestConfig) => {
  const url = '/weaver/api/v1/ugc/fm/submit_fm_draft';

  if (platform.isNativePlatform) {
    return createNativeRequest<ISubmitFMDraftResp>({
      method: 'POST',
      url,
      data: params,
    });
  }

  return request.post<ISubmitFMDraftResp>(url, params, config);
};

export const postGenerateFMDraft = async (
  params: IGenerateFMDraftReq,
  config?: AxiosRequestConfig
) => {
  const url = '/weaver/api/v1/ugc/fm/generate_fm_draft';

  if (platform.isNativePlatform) {
    return createNativeRequest<IGenerateFMDraftResp>({
      method: 'POST',
      url,
      data: params,
    });
  }

  return request.post<IGenerateFMDraftResp>(url, params, config);
};

export const postDeleteFMDraft = async (params: IDeleteFMDraftReq, config?: AxiosRequestConfig) => {
  const url = '/weaver/api/v1/ugc/fm/delete_fm_draft';

  if (platform.isNativePlatform) {
    return createNativeRequest<IDeleteFMDraftResp>({
      method: 'POST',
      url,
      data: params,
    });
  }

  return request.post<IDeleteFMDraftResp>(url, params, config);
};

export const postUpdateFmDraft = async (params: IUpdateFMDraftReq, config?: AxiosRequestConfig) => {
  const url = '/weaver/api/v1/ugc/fm/update_fm_draft';

  if (platform.isNativePlatform) {
    return createNativeRequest<IUpdateFMDraftResp>({
      method: 'POST',
      url,
      data: params,
    });
  }

  return request.post<IUpdateFMDraftResp>(url, params, config);
};

export const postPreviewTone = async (params: IPreviewToneReq, config?: AxiosRequestConfig) => {
  const url = '/weaver/api/v1/npc_editor/preview/tone';

  if (platform.isNativePlatform) {
    return createNativeRequest<IPreviewToneResp>({
      method: 'POST',
      url,
      data: params,
    });
  }

  return request.post<IPreviewToneResp>(url, params, config);
};

export const postQueryBgmCategoryList = async (
  params: IQueryBgmCategoryListReq,
  config?: AxiosRequestConfig
) => {
  const url = '/weaver/api/v1/bgm/query_category_list';

  if (platform.isNativePlatform) {
    return createNativeRequest<IQueryBgmCategoryListResp>({
      method: 'POST',
      url,
      data: params,
    });
  }

  return request.post<IQueryBgmCategoryListResp>(url, params, config);
};

export const postPageQueryBgmListByTagId = async (
  params: IPageQueryBgmListByTagIdReq,
  config?: AxiosRequestConfig
) => {
  const url = '/weaver/api/v1/bgm/query_bgm_list';

  if (platform.isNativePlatform) {
    return createNativeRequest<IPageQueryBgmListByTagIdResp>({
      method: 'POST',
      url,
      data: params,
    });
  }

  return request.post<IPageQueryBgmListByTagIdResp>(url, params, config);
};

export const postGetNpcProfile = async (params: IGetNpcProfileReq, config?: AxiosRequestConfig) => {
  const url = '/weaver/api/v1/npc/get_npc_profile';

  if (platform.isNativePlatform) {
    return createNativeRequest<IGetNpcProfileResp>({
      method: 'POST',
      url,
      data: params,
    });
  }

  return request.post<IGetNpcProfileResp>(url, params, config);
};

export const postGetFmDraft = async (params: IGetFmDraftReq, config?: AxiosRequestConfig) => {
  const url = '/weaver/api/v1/ugc/fm/get_fm_draft_profile';

  if (platform.isNativePlatform) {
    return createNativeRequest<IGetFmDraftResp>({
      method: 'POST',
      url,
      data: params,
    });
  }

  return request.post<IGetFmDraftResp>(url, params, config);
};

export const postModerationText = async (
  params: IModerationTextReq,
  config?: AxiosRequestConfig
) => {
  const url = '/weaver/api/v1/npc_editor/moderation_text';

  if (platform.isNativePlatform) {
    return createNativeRequest<IModerationTextResp>({
      method: 'POST',
      url,
      data: params,
    });
  }

  return request.post<IModerationTextResp>(url, params, config);
};

export const postDeleteFmDraft = async (params: IDeleteFmDraftReq, config?: AxiosRequestConfig) => {
  const url = '/weaver/api/v1/ugc/fm/delete_fm_draft';

  if (platform.isNativePlatform) {
    return createNativeRequest<IDeleteFmDraftResp>({
      method: 'POST',
      url,
      data: params,
    });
  }

  return request.post<IDeleteFmDraftResp>(url, params, config);
};
